export default __webpack_public_path__ + "static/media/motocross-outline.5fc7b43f.png";